import * as api from '@api/message/api-function';
import { useApiMutation } from '@hook/common/useApi';
import { ICreatePushTokenRequest } from '@datatype/message/api-type';
import { IApiResponse } from '@datatype/common/api-type';
import { IPushTokenData } from '@datatype/message/api-type';

// ############### push token ###############
export const useCreatePushTokenMutation = () => {
  return useApiMutation<IApiResponse<IPushTokenData>, ICreatePushTokenRequest>(api.createPushToken, {});
};
